import { Locale } from '@ps-smart-cp/ppfw-client';

const interestClassBookSettingConfig = {
  interestExcluded: new Map([
    [Locale.ja, '利子抜き'],
    [Locale.en, 'Interest Excluded'],
  ]),
  interestIncluded: new Map([
    [Locale.ja, '利子込み'],
    [Locale.en, 'Interest Included'],
  ]),
};

export { interestClassBookSettingConfig };
